module.exports = __webpack_public_path__ + "img/es.e972cb47.svg";